import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import {
  Container,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import { APIgetFTPImportFiles } from '../../api/Importers';

import AdminHeader from '../../components/Admin/Header';
import AdminFooter from '../../components/Admin/Footer';
import AdminFTPQueueList from '../../components/Admin/FTPQueue/List';
import AdminFTPQueueFilters from '../../components/Admin/FTPQueue/Filters';

import { getVisibleItemsText } from '../../helpers';
import { getUserSetting } from '../../helpers/Settings';

import ErrorBoundary from '../../components/ErrorBoundary';
import Loading from '../../components/Loading';
import { handleComponentParams, handleURLParams } from '../../helpers/URLParams';
import EmptyFTPQueue from '../EmptyContainers/FTPQueue';

class AdminFTPQueue extends Component {
  constructor(props) {
    super(props);

    this.state = {
      files: [],
      filesTotal: 0,
      counts: {},
      fileStatuses: {},
      selectedFileStatuses: ['failed', 'pending'],
      page: 1,
      perPage: getUserSetting('admin_per_page') || 20,
      orderBy: 'created_at',
      order: 'desc',
      loading: true,
    };

    this.interval = null;

    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeFilter = this.handleChangeFilter.bind(this);
    this.loadFiles = this.loadFiles.bind(this);
  }

  componentDidUpdate(prevProps) {
    handleComponentParams(
      false,
      ['page', 'selectedFileStatuses', 'orderBy', 'order'],
      prevProps,
      this.setState.bind(this),
      () => {
        this.interval = setInterval(() => {
          this.loadFiles(true);
        }, 5000);

        this.loadFiles();
      },
      { orderBy: 'created_at', order: 'desc', selectedFileStatuses: ['failed', 'pending'] },
    );
  }

  componentDidMount() {
    const { history, location } = this.props;
    const { selectedFileStatuses, orderBy, order } = this.state;

    const queryParams = new URLSearchParams(location.search);

    if (!queryParams.get('selectedFileStatuses')) {
      handleURLParams({ selectedFileStatuses }, history);
    }
    if (!queryParams.get('orderBy')) {
      handleURLParams({ orderBy }, history);
    }
    if (!queryParams.get('order')) {
      handleURLParams({ order }, history);
    }

    handleComponentParams(
      true,
      ['page', 'selectedFileStatuses', 'orderBy', 'order'],
      null,
      this.setState.bind(this),
      () => {
        this.interval = setInterval(() => {
          this.loadFiles(true);
        }, 5000);

        this.loadFiles();
      },
      { orderBy: 'created_at', order: 'desc', selectedFileStatuses: ['failed', 'pending'] },
    );
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  loadFiles(silent = false) {
    const {
      selectedFileStatuses,
      page,
      perPage,
      orderBy,
      order,
      loading,
    } = this.state;

    const filteredSelectedFileStatuses = selectedFileStatuses.filter(i => (i !== 'all'));

    if (!silent) {
      this.setState({ loading: true });
    } else if (page > 1 || loading) {
      return;
    }

    APIgetFTPImportFiles({
      statuses: filteredSelectedFileStatuses,
      page,
      per_page: perPage,
      order_by: orderBy,
      order,
    }).then((response) => {
      const { data } = response;
      if (data) {
        this.setState({
          loading: false,
          files: data.data,
          filesTotal: data.meta.total,
          counts: data.meta.counts,
          fileStatuses: data.meta.statuses,
        });
      }
    });
  }

  handleChangeOrder(orderBy, order) {
    const { history } = this.props;
    handleURLParams({ orderBy, order, page: 1 }, history);

    this.setState({
      orderBy,
      order,
      page: 1,
    });
  }

  handleChangePage(page) {
    const { history } = this.props;
    handleURLParams({ page }, history);

    this.setState({ page });
  }

  handleChangeFilter(e) {
    const {
      name,
      checked,
      value,
      type,
    } = e.target;
    let { [name]: newValue } = this.state;
    const { history } = this.props;

    if (type === 'checkbox') {
      if (!value) {
        newValue = [];
      } else if (value === 'all') {
        newValue = ['all'];
      } else if (checked) {
        newValue.push(value);
      } else {
        newValue = newValue.filter(i => (i !== value && value !== 'all'));
      }

      if (newValue.length > 1) {
        newValue = newValue.filter(i => (i !== 'all'));
      }
      if (newValue.length === 0) {
        newValue = ['all'];
      }
    }

    handleURLParams({ [name]: newValue, page: 1 }, history);
    this.setState({ [name]: newValue, page: 1 });
  }

  render() {
    const {
      intl,
    } = this.props;
    const {
      page,
      perPage,
      filesTotal,
      counts,
      fileStatuses,
      selectedFileStatuses,
      loading,
    } = this.state;

    return (
      <div className="main-content ftp-queue-content">
        <Container fluid>
          <AdminHeader
            title={intl.formatMessage({ defaultMessage: 'FTP queue' })}
            icon="fa-file-arrow-up"
            itemName="file"
            itemsTotal={filesTotal}
            itemsVisible={getVisibleItemsText(page, perPage, filesTotal)}
            showNewItemButton={false}
            loading={loading}
          />
          <AdminFTPQueueFilters
            counts={counts}
            fileStatuses={fileStatuses}
            selectedFileStatuses={selectedFileStatuses}
            loading={loading}
            handleChangeFilter={this.handleChangeFilter}
          />
          {loading ? (
            <Loading />
          ) : (
            <div className="content-wrapper">
              <ErrorBoundary>
                {filesTotal > 0 ? (
                  <AdminFTPQueueList
                    {...this.state}
                    loadFiles={this.loadFiles}
                    handleChangeOrder={this.handleChangeOrder}
                  />
                ) : (
                  <>
                    {counts.all > 0 && (
                      <div className="nothing-found-wrapper">
                        <h3>{intl.formatMessage({ defaultMessage: 'No files found' })}</h3>
                        <p>{intl.formatMessage({ defaultMessage: 'Try to change selected filters' })}</p>
                      </div>
                    )}
                    {counts.all === 0 && (
                      <EmptyFTPQueue />
                    )}
                  </>
                )}
              </ErrorBoundary>
              <ErrorBoundary>
                <AdminFooter
                  {...this.state}
                  itemsTotal={filesTotal}
                  handleChangePage={this.handleChangePage}
                />
              </ErrorBoundary>
            </div>
          )}
        </Container>
      </div>
    );
  }
}

AdminFTPQueue.propTypes = {
  intl: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export default withRouter(injectIntl(AdminFTPQueue));
